<template>
    <div id="controls" class="p-2">
        <div class="form-group">
            <label class="form-label">
                Intraoral image opacity
            </label>
            <input class="slider tooltip" type="range" min="0" max="100"
                   :data-tooltip="intraOralOpacity + '%'"
                   v-model="intraOralOpacity"
                   :disabled="currentState.matches('alignExtraOral')">
        </div>

        <div class="form-group">
            <label class="form-switch">
                <input type="checkbox" v-model="showReferenceLines">
                <i class="form-icon"></i> Reference lines
            </label>
        </div>

        <div class="form-group" v-if="isCategory('design')">
            <label class="form-switch">
                <input type="checkbox" v-model="showOriginalCurvesAndAxes">
                <i class="form-icon"></i> Original curves and tooth axes
            </label>
        </div>

        <div class="form-group" v-if="isCategory('design')">
            <label class="form-switch">
                <input type="checkbox" v-model="showOriginalContours">
                <i class="form-icon"></i> Original contours
            </label>
        </div>

        <div class="form-group" v-if="isCategory('design')">
            <label class="form-switch">
                <input type="checkbox" v-model="showPlanPoints">
                <i class="form-icon"></i> Control points
            </label>
        </div>

<!--        <div class="form-group" v-if="isCategory('design')">-->
<!--            <label class="form-switch">-->
<!--                <input type="checkbox" v-model="showPlanBoundingBoxes">-->
<!--                <i class="form-icon"></i> Show bounding box-->
<!--            </label>-->
<!--        </div>-->
    </div>
</template>

<script>
    export default {
        name: "Controls",
        computed: {
            // State methods
            currentState () {
                return this.$store.state.currentState
            },

            // Controls
            intraOralOpacity: {
                get () {
                    return this.$store.state.intraOralOpacity
                },
                set (value) {
                    this.$store.commit('updateIntraOralOpacity', value)
                }
            },

            showReferenceLines: {
                get () {
                    return this.$store.state.showReferenceLines
                },
                set (value) {
                    this.$store.commit('showReferenceLines', value)
                }
            },

            showOriginalCurvesAndAxes: {
                get () {
                    return this.$store.state.showOriginalCurvesAndAxes
                },
                set (value) {
                    this.$store.commit('showOriginalCurvesAndAxes', value)
                }
            },

            showOriginalContours: {
                get () {
                    return this.$store.state.showOriginalContours
                },
                set (value) {
                    this.$store.commit('showOriginalContours', value)
                }
            },

            showPlanPoints: {
                get () {
                    return this.$store.state.showPlanPoints
                },
                set (value) {
                    this.$store.commit('showPlanPoints', value)
                }
            },

            showPlanBoundingBoxes: {
                get () {
                    return this.$store.state.showPlanBoundingBoxes
                },
                set (value) {
                    this.$store.commit('showPlanBoundingBoxes', value)
                }
            },
        },
        methods: {
            isCategory(name) {
                return this.$store.getters.isCategory(name)
            },
        }
    }
</script>

<style scoped>

</style>